<template>
<div class="chapter">
<div class="inner_page">
<h2 class="sec_chap">List of Tables</h2>
<p class="hanging">The 20th Army’s Composition as of 6 August</p>
<p class="hanging">Daily Correlation of Forces on 20th Army’s Front</p>
<p class="hanging">Equipment withdrawn from the Western Bank to the Eastern Bank of the Dnepr River by 20th Army</p>
<p class="hanging">20th Army’s Combat Composition on 15 August 1941</p>
<p class="hanging">A List of the Trophy [Captured] Property Seized by 19th Army’s Formations during the Period from 17 through 30 August 1941</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_List_Tables.vue?1575bafa